module.exports = __webpack_public_path__ + "media/images/ratrustvox-white-ba5774cac5ece2e73a21de2e70aab481.svg";